import { useState } from 'react';

/**
 * Expandable "Como se calcula?" detail component
 * Collapsed by default, reveals explanation on click
 */
export default function CalcDetail({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="calc-detail">
      <button
        className="calc-detail-toggle"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        {open ? 'Ocultar detalle' : 'Como se calcula?'}
      </button>
      {open && <div className="calc-detail-content">{children}</div>}
    </div>
  );
}
